var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack6Solid48({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 1,
    y: 1,
    width: 14,
    height: 14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.67,9.75H7.3V9.39A2.32,2.32,0,0,1,7.52,8.3a3.37,3.37,0,0,1,.88-1,7.5,7.5,0,0,0,.79-.7,1,1,0,0,0,.2-.58A1,1,0,0,0,9,5.29,1.38,1.38,0,0,0,8.09,5a1.42,1.42,0,0,0-1,.33,1.66,1.66,0,0,0-.53,1L5.21,6.13A2.29,2.29,0,0,1,6,4.5a2.89,2.89,0,0,1,2-.67,3,3,0,0,1,2.07.68,2.06,2.06,0,0,1,.77,1.58,1.69,1.69,0,0,1-.28.94A6,6,0,0,1,9.37,8.25a2.25,2.25,0,0,0-.59.64A2.18,2.18,0,0,0,8.67,9.75Zm-1.37,2V10.27H8.81v1.51Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack6Solid48);
export default __webpack_public_path__ + "static/media/Symbolpack_6_solid_48.8ccdf20bfcb3d314b256637c2174ce8b.svg";
export { ForwardRef as ReactComponent };